import { inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IInventoryProductLogsResponse } from "../../types";

// Fetch inventory product logs by product ID
export const fetchInventoryProductLogs = createServiceAsyncThunk<
  IInventoryProductLogsResponse,
  number // productId
>(
  ACTION_NAMES.FETCH_INVENTORY_PRODUCT_LOGS, 
  (productId) => inventoryProductService.getLogsByProductId(productId),
  ERROR_MESSAGES.FETCH_INVENTORY_PRODUCT_LOGS_FAILURE
);

export const inventoryProductLogsSlice = createGenericSlice<
  IInventoryProductLogsResponse,
  number
>(
  SLICE_NAMES.INVENTORY_PRODUCT_LOGS_SLICE, 
  fetchInventoryProductLogs
);

export const {
  clearError: clearInventoryProductLogsError,
  clearSuccessMessage: clearInventoryProductLogsSuccessMessage,
} = inventoryProductLogsSlice.actions;

export default inventoryProductLogsSlice.reducer;
